import React, { useCallback, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl } from 'gatsby-plugin-react-intl';
import { Button } from '@material-ui/core';
import csvtojson from 'csvtojson';

// Components
import SEO from '../components/SEO';
import Layout from '../components/Layout';
import Form from '../components/Form';

// Utils
import { isClient } from '../utils/utils';

const useStyles = makeStyles((theme) => ({
    buttonsWrapper: {
        textAlign: 'right',
        padding: '20px',
    },
}));

const HomePage = () => {
    const intl = useIntl();
    const classes = useStyles();
    const [years, setYears] = useState([(new Date()).getFullYear()]);
    const [initialValues, setInitialValues] = useState({});
    const personalInfoFields = ['name', 'email', 'phone'];

    const handleAddYear = useCallback(() => {
        setYears([
            ...years,
            years[years.length - 1] - 1,
        ].sort((a, b) => b - a));
    }, [years]);

    useEffect(() => {
        const getDataFromSpreadsheet = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const userId = urlParams.get('userId') || 0;
            const spreadsheetId = urlParams.get('spreadsheetId');

            if (!spreadsheetId) {
                return;
            }

            const response = await fetch(
                `https://docs.google.com/spreadsheets/d/e/${spreadsheetId}/pub?gid=1016831492&output=csv`, {
                    method: 'GET',
                }
            );

            const text = await response.text();
            const json = await csvtojson({ output: 'csv' })
                .fromString(text)
                .then((csvRow) => csvRow);

            const formValues = JSON.parse(json[userId][1]);
            setInitialValues(formValues);
            setYears(
                Object.keys(formValues).filter(
                    (name) => !personalInfoFields.includes(name)
                ).sort((a, b) => b - a)
            );
        };

        if (isClient()) {
            getDataFromSpreadsheet();
        }
    }, [personalInfoFields]);

    return (
        <Layout>
            <SEO
                title={intl.formatMessage({ id: 'home' })}
                robots="noindex, nofollow"
            />
            <Button
                onClick={handleAddYear}
                variant="contained"
                color="primary"
            >
                Add year
            </Button>
            <Form
                years={years}
                initialValues={initialValues}
            />
        </Layout>
    );
};

export default HomePage;
